module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/secondHistoryImage-f36ebd9438e187d185af1b76d5f05cbe.png";